import { IMobileNavigationProfile } from "TfsCommon/Scripts/MobileNavigation/Model";

export interface IProfileProps {
    profile: IMobileNavigationProfile;
}
